export default "__VITE_ASSET__KEOV$wYW__"